import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
    const location = useLocation();

    return (
        <header className="container-fluid shadow-sm bg-white" style={{ zIndex: 100, position: 'relative', padding: "0 10vw" }}>
            <nav className="navbar navbar-expand-lg">
                <Link className="navbar-brand" to="/" title="Ana Sayfaya Git">
                    <img style={{ maxWidth: '8vh' }} src="/logo192.png" alt="Legalbul Logo" loading="lazy" />
                </Link>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent" style={{ marginRight: "15%" }}>
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link className={`nav-link ${location.pathname === "/" ? "text-orange" : ""}`} to="/">Ana Sayfa</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link ${location.pathname === "/hesaplamalar" ? "text-orange" : ""}`} to="/hesaplamalar">Tüm Hesaplamalar</Link>
                        </li>
                        {/*
                        <li className="nav-item">
                            <Link className={`nav-link ${location.pathname === "/sozlesmeler" ? "text-orange" : ""}`} to="/sozlesmeler">Tüm Sözleşmeler</Link>
                        </li>
                        */}
                        <li className="nav-item">
                            <Link className={`nav-link ${location.pathname === "/blog" ? "text-orange" : ""}`} to="/blog">Bloglar</Link>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
    );
};

export default React.memo(Header);
